import React from 'react';

import './CTABanner.css';

const CTABanner = () => <div className="cta-banner bg-gradient-purple p-4">
  <div className="text-left">
    <img src="assets/logo-white.png" width="150px"/>
    <div className="cta-banner-text">The simplest way to share your web project</div>
  </div>
  <div className="flex-grow-1">
    <a href="https://tiiny.host"><button className="border-button m-auto">Upload Free Site</button></a>
  </div>
</div>

export default CTABanner;
